import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CuratedSpecialtiesImport } from '../../../core/models/curated-specialties-import.model';
import { CuratedSpecialtiesService } from '../../../core/services/curated-specialties.service';
import { LimitOffsetPaging } from 'app/core/models/paged-results/limit-offset-paging.model';
import { ImportNavComponent } from '../../../shared/components/import-nav/import-nav.component';
import { DecimalPipe, TitleCasePipe, DatePipe } from '@angular/common';
import { PaginationHeaderComponent } from '../../../shared/components/pagination-header/pagination-header.component';
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-capture-admin-import-curated-specialties-history',
    templateUrl: './capture-admin-import-curated-specialties-history.component.html',
    styleUrls: ['./capture-admin-import-curated-specialties-history.component.scss'],
    imports: [ImportNavComponent,
              PaginationHeaderComponent,
              PaginationComponent,
              MatProgressSpinner,
              DecimalPipe,
              TitleCasePipe,
              DatePipe]
})
export class CaptureAdminImportCuratedSpecialtiesHistoryComponent implements OnInit, OnDestroy {
  private curatedSpecialtiesService = inject(CuratedSpecialtiesService);

  loading = false;
  curatedSpecialtiesImports: CuratedSpecialtiesImport[] = [];
  nextCheckTimeout = null;
  paging: LimitOffsetPaging;

  ngOnInit() {
    this.paging = LimitOffsetPaging.empty;
    this.paging.currentPage = 1;
    this.loadImports(this.paging.currentPage);
  }

  ngOnDestroy() {
    clearTimeout(this.nextCheckTimeout);
  }

  onPageSizeChange(size: number) {
    this.paging.pageSize = size;
    this.loadImports(this.paging.currentPage);
  }

  onPageChange(page: number) {
    this.loadImports(page);
  }

  private loadImports(page, loading = true) {
    this.loading = loading;
    const paging = { page, pageSize: this.paging.pageSize };
    this.curatedSpecialtiesService.getList(paging).subscribe(result => {
      this.curatedSpecialtiesImports = result.curatedSpecialtiesImports;
      this.paging = result.meta.paging;
      this.loading = false;

      const anyActive: boolean = this.curatedSpecialtiesImports.some(record => record.active);

      if (anyActive) {
        this.nextCheckTimeout = setTimeout(() => this.loadImports(this.paging.currentPage, false), 5000);
      }
    });
  }
}
